import { isEqual } from "lodash";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const searchString = ref<string | undefined>(undefined);

export const useSearchStringFilter = () => {
  const route = useRoute();
  const router = useRouter();

  watch(
    () => route.query,
    (newParams, oldParams) => {
      if (newParams !== oldParams) {
        const newSearchString = Array.isArray(newParams.searchString)
          ? (newParams.searchString?.[0] ?? undefined)
          : (newParams.searchString ?? undefined);
        if (!isEqual(newSearchString, searchString.value)) {
          searchString.value = newSearchString;
        }
      }
    },
    { immediate: true },
  );

  const updateSearchStringFilter = async (value?: string) => {
    searchString.value = value;
    await router.push({
      query: {
        ...route.query,
        searchString: value,
      },
    });
  };

  return { searchString, updateSearchStringFilter };
};
